module.exports = __webpack_public_path__ + "media/images/icon__point--white@2x-200b4946827313963f8595349ad421e1.png";